import { getCart } from "./update";

const checkoutButton = document.querySelector('#cart-checkout-btn');

checkoutButton?.addEventListener("click", requestCheckoutSession);

/**
 * Function to request a Stripe checkout session from a custom WordPress API route and redirect the user to that url.
 */
function requestCheckoutSession() {
    // Disable checkout button in cart while request
    checkoutButton.setAttribute("disabled", true);

    // Request checkout session from custom WordPress API route
    fetch('/wp-json/f5/v1/checkout-session')
        .then(response => response.json())
        .then(data => {
            // Redirect user to checkout url from response data.           
            if (typeof window !== "undefined" && data.checkout_url) {
                window.location = data.checkout_url;
            }
        })
        .catch(error => {
            // Handle any errors that occurred during the fetch
            console.error('Failed requesting checkout session:', error);
            alert("Beim Anfordern des Checkout Session ist ein Fehler aufgetreten.");
        });
}